import React from "react";
import {
  Chip,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import CommonPage from "@icarius-common/commonPage";
import { CloseIcon } from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";
import MainContent from "./mainSection/mainContent";
import ActivityExtras from "./mainSection/activityExtras";
import Sidebar from "./sidebar";

const TrainingExecution = (props) => {

  const {
    isLoading,
    trainingData,
    activityData,
    handleShowParticipants,
    handleClose,
  } = props;

  return (
    <div style={{ marginBottom: 20 }}>
      <CommonPage
        isLoading={isLoading}
        isNotGridPage
      >
        <Grid container item xs={12} alignItems="center" justify="space-between" style={{ paddingLeft: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Typography className="whiteText" style={{ fontWeight: 700, padding: "16px 0px" }}>
              {trainingData.name}
            </Typography>
            {
              trainingData.isInstructor &&
              <Chip
                size="small"
                label={getLocalizedString("instructor")}
                style={{
                  background: "var(--ownBlue)",
                  color: "white",
                }}
              />
            }
            {
              (!trainingData.isInstructor && !trainingData.isParticipant) &&
              <Chip
                size="small"
                label={getLocalizedString("readOnlyAdmin")}
                style={{
                  background: "var(--ownBlue)",
                  color: "white",
                }}
              />
            }
          </div>
          <IconButton onClick={handleClose}>
            <CloseIcon className="whiteText" />
          </IconButton>
        </Grid>
        <Grid container style={{ padding: "0px 15px" }}>
          <Grid container item sm={12} md={8}>
            <div
              style={{
                margin: 8,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <MainContent
                key={activityData.id} // para que recargue bien cuando cambia de actividad
                trainingData={trainingData}
                activityData={activityData}
              />
              <div style={{ minHeight: 135 }}>
                <ActivityExtras
                  key={activityData.id} // para que reiniciarle el state cuando cambia de actividad
                  trainingData={trainingData}
                  activityData={activityData}
                />
              </div>
            </div>
          </Grid>
          <Grid container item sm={12} md={4}>
            <Sidebar
              trainingData={trainingData}
              selectedActivityId={activityData?.id}
              handleShowParticipants={handleShowParticipants}
            />
          </Grid>
        </Grid>
      </CommonPage>
    </div>
  )
}

export default TrainingExecution;